import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import MapsProvider from './components/MapsProvider';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import ResponsiveLayout from './components/ResponsiveLayout';
import Contracts from './pages/Contracts';
import Users from './pages/Users';
import Consommation from './pages/Consommation';
import Factures from './pages/Factures';
import Tranches from './pages/Tranches';
import Secteurs from './pages/Secteurs';
import Login from './pages/Login';
import Unauthorized from './pages/Unauthorized';

function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/" replace />;
}

function RoleRoute({ role, children }) {
  const userRole = localStorage.getItem('role');
  const normalizedUserRole = userRole?.toLowerCase();
  const normalizedRequiredRole = role?.toLowerCase();
  
  return normalizedUserRole === normalizedRequiredRole ? children : <Navigate to="/unauthorized" replace />;
}

function Layout() {
  return (
    <ResponsiveLayout>
      <Outlet />
    </ResponsiveLayout>
  );
}

function App() {
  return (
    <Router>
        <MapsProvider>
        <Routes>

          {/* Route Login */}
          <Route path="/" element={<Login />} />

          {/* Admin */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <RoleRoute role="admin">
                  <Layout />
                </RoleRoute>
              </ProtectedRoute>
            }
          >
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="clients" element={<Clients />} />
            <Route path="contracts" element={<Contracts />} />
            <Route path="utilisateurs" element={<Users />} />
            <Route path="consommations" element={<Consommation />} />
            <Route path="factures" element={<Factures />} />
            <Route path="tranches" element={<Tranches />} />
            <Route path="secteurs" element={<Secteurs />} />
          </Route>

          {/* Technicien */}
          <Route
            path="/technicien"
            element={
              <ProtectedRoute>
                <RoleRoute role="tech">
                  <Layout />
                </RoleRoute>
              </ProtectedRoute>
            }
          >
            <Route path="consommation" element={<Consommation />} />
            <Route path="clients" element={<Clients />} />
            <Route path="factures" element={<Factures />} />
          </Route>

          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    </MapsProvider>
      </Router>
  );
}

export default App;
